module.exports = __webpack_public_path__ + "static/media/59.21dcf75c.jpg";